import React from 'react';
import { Fragment } from 'react';
import { Row, Col, Container, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import Header from '../../components/header';
import Footer from '../../components/footer';
import Head from '../../components/head';
import Item from '../../components/itens/item'


function SocialScreen() {
    return (
        <Fragment>
            <Head titulo="Secretaria de Desenvolvimento Social e Direitos Humanos de Macuco" />
            <Header />
            <Container>
                <Row xs={1}>
                    <Col xs={{ span: 2, offset: 11 }}>
                        <Link to='/'>
                            <Button type='button' variant='danger'>Voltar</Button>
                        </Link>
                    </Col>
                </Row>
                <br />
                <br />
                <Row xs={1} lg={3}>
                     <Col>
                        <Item
                            titulo={"Programa Auxílio Macuco"}
                            descricao={"Veja aqui como acessar o programa 'Auxílio Macuco' e a legislação a respeito do assunto."}
                            awesome={"faHandHoldingHand"}
                            link={"social/auxiliomacuco"}
                            key={1}
                        />
                    </Col>
                    <Col>
                        <Item
                            titulo={"Unidades de Assistência Social"}
                            descricao={"Veja aqui todas unidades de assistência social em nosso município, seu horário de funcionamento e seus contatos."}
                            awesome={"faHandsHoldingChild"}
                            link={"orgaos/locais/social"}
                            key={1}
                        />
                    </Col>
                </Row>
            </Container>
            <Footer />
        </Fragment>
    );
}

export default SocialScreen;